(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nookverra-product"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initialize(root) {
    if (root.dataset.nvReady === 'true') return;
    root.dataset.nvReady = 'true';
    const form = root.querySelector('form.nv-native-form');
    const variantInput = form?.querySelector('[data-nv-variant-input]');
    const addButton = form?.querySelector('[data-nv-add]');
    const priceLabel = form?.querySelector('[data-nv-selected-price]');
    const payment = form?.querySelector('[data-nv-payment]');
    if (variantInput) variantInput.disabled = false;
    root.addEventListener('change', (event) => {
      const radio = event.target;
      if (!(radio instanceof HTMLInputElement) || !radio.matches('[data-nv-pack]')) return;
      if (!variantInput || !addButton) return;
      variantInput.value = radio.value;
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      addButton.disabled = radio.dataset.available !== 'true';
      const addLabel = form.querySelector('[data-nv-add-label]');
      if (addLabel) addLabel.textContent = addButton.disabled ? root.dataset.soldoutLabel : root.dataset.addLabel;
      if (priceLabel) priceLabel.textContent = radio.dataset.priceLabel || '';
      if (payment) payment.hidden = addButton.disabled;
      const stickyButton = root.querySelector('[data-nv-sticky-add]');
      if (stickyButton) stickyButton.disabled = addButton.disabled;
      const stickyPrice = root.querySelector('[data-nv-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = radio.dataset.priceLabel || '';
      const stickyPack = root.querySelector('[data-nv-sticky-pack]');
      if (stickyPack) stickyPack.textContent = radio.dataset.packLabel || '';
    });
    root.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const thumbnail = event.target.closest('[data-nv-thumbnail]');
      if (!thumbnail) return;
      const image = root.querySelector('.nv-main-image');
      if (!(image instanceof HTMLImageElement)) return;
      image.srcset = thumbnail.dataset.srcset || '';
      image.src = thumbnail.dataset.src || image.src;
      image.alt = thumbnail.dataset.alt || '';
      root.querySelectorAll('[data-nv-thumbnail]').forEach((button) => {
        button.setAttribute('aria-current', String(button === thumbnail));
      });
    });
  }
  document.querySelectorAll('[data-nookverra-product]').forEach(initialize);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-nookverra-product]').forEach(initialize);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
